// extracted by mini-css-extract-plugin
module.exports = {"backToLatestArticle":"b2b-back-to-latest-article_backToLatestArticle__ZW41R"};